// The queries the pages share, so moving between pages reuses what was already read.
import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export const usePosts = () => useQuery({ queryKey: ["posts"], queryFn: api.posts });
export const usePost = (slug: string) => useQuery({ queryKey: ["post", slug], queryFn: () => api.post(slug) });
export const useWorkflows = (category?: string, q?: string) =>
  useQuery({ queryKey: ["workflows", category ?? "", q ?? ""], queryFn: () => api.workflows(category, q), placeholderData: (prev) => prev });
export const useWorkflow = (slug: string) => useQuery({ queryKey: ["workflow", slug], queryFn: () => api.workflow(slug) });
export const useVersion = (slug: string, version: number | undefined, enabled: boolean) =>
  useQuery({ queryKey: ["workflow", slug, version], queryFn: () => api.version(slug, version!), enabled: enabled && version !== undefined });
export const useCharter = () => useQuery({ queryKey: ["charter"], queryFn: api.charter });
